/* cover */
/*--------------------------------------------------------------------------------*/
export const loading = (
    cover: HTMLElement,
    state = false,
    align = 'top',
    hide = true,
) => {
    const inner = cover.querySelectorAll<HTMLElement>('*');
    if (state) {
        cover.querySelector<HTMLElement>('.cover-loader')?.remove();
        cover.style.position = 'relative';
        if (hide) inner.forEach(el => el.style.visibility = 'hidden');
        // create loader
        const loader = document.createElement('div');
        loader.className = `cover-loader ${align}`;
        loader.innerHTML = `<div class="spinner s28"></div>`;
        cover.appendChild(loader);
    } else {
        new Promise(r => setTimeout(r, 400)).then(() => {
            cover.querySelector<HTMLElement>('.cover-loader')?.remove();
            cover.style.position = '';
            inner.forEach(el => el.style.visibility = '');
        });
    }
};
/*--------------------------------------------------------------------------------*/
// accordion
export const acdInit = () => {
    const acdItem = document.querySelectorAll<HTMLElement>('.acd-item');
    acdItem.forEach(elm => {
        const topic = elm.querySelector<HTMLElement>('.topic');
        const panel = elm.querySelector<HTMLElement>('.panel');
        if (topic) topic.onclick = () => {
            elm.classList.toggle('active');
            if (!panel) return;
            if (elm.classList.contains('active')) {
                panel.style.maxHeight = `${panel.scrollHeight}px`;
            } else {
                panel.style.maxHeight = '';
            }
        };
    });
};
/*--------------------------------------------------------------------------------*/
